module.exports = "pegasus/assets/two-column-image-text-button-preview.png";